import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { parseLabRoute } from "./domain/routes";
import { DemoViewerProvider } from "./domain/demo-viewer";
import { AiEnginePage } from "./pages/AiEnginePage";
import { EditorialManagementPage } from "./pages/EditorialManagementPage";
import { ExamplePage } from "./pages/ExamplePage";
import { HomeFeedPage } from "./pages/HomeFeedPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { OverviewPage } from "./pages/OverviewPage";
import { SourcesPage } from "./pages/SourcesPage";
import { UnitDetailPage } from "./pages/UnitDetailPage";
import { InternalFeedItemsPage, UnitsPage } from "./pages/UnitsPage";
import "./pages/ai-engine.css";
import "./pages/editorial-management.css";
import "./pages/overview.css";
import "./pages/sources.css";
function PrototypeEntry() {
    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        query.delete("access");
        query.delete("game");
        query.delete("tab");
        const search = query.toString();
        window.history.replaceState(null, "", `/home/${search ? `?${search}` : ""}${window.location.hash}`);
    }, []);
    return _jsx(HomeFeedPage, {});
}
function RoutedApp() {
    const route = parseLabRoute(window.location.pathname);
    switch (route.kind) {
        case "overview":
            return _jsx(OverviewPage, {});
        case "home":
            return _jsx(PrototypeEntry, {});
        case "units":
            return _jsx(UnitsPage, {});
        case "sources":
            return _jsx(SourcesPage, {});
        case "story-engine":
            return _jsx(AiEnginePage, {});
        case "editorial-management":
            return _jsx(EditorialManagementPage, {});
        case "internal-feed-items":
            return _jsx(InternalFeedItemsPage, {});
        case "internal-feed-item":
            return _jsx(UnitDetailPage, { code: route.unitCode });
        case "internal-feed-example":
            return (_jsx(ExamplePage, { exampleId: route.exampleId, itemKind: route.itemKind }));
        case "not-found":
            return _jsx(NotFoundPage, { path: route.path });
    }
}
export function App() {
    return (_jsx(DemoViewerProvider, { children: _jsx(RoutedApp, {}) }));
}
